import React from 'react';
import { motion } from 'framer-motion';
import { CountryFlag } from '../../Utils/flags';
import { convertTime } from '../HeadToHead/utils';
import { secondsInPast } from '../../Utils/time';
// import { AppContext } from "../../App";
import { List as Advertisement } from '../Advertisement/list';

import style from './results.module.scss';

const Athlete = ({
  athlete,
  index,
  status,
  result,
  delaySeconds,
  result_changes,
  animate,
  advertising,
  approaching
}) => {
  const { first_name, last_name, nationality } = athlete;
  const { iso3 } = nationality;
  let resultDate;
  let inPast = false;
  let rank = result ? result.rank : undefined;
  let timeToFirst = result ? result.time_to_first : undefined;
  let time = result ? result.time : undefined;

  if (result_changes && Array.isArray(result_changes) && result_changes.length) {
    //setRank
    const rankChange = result_changes.filter((change) => change.type === 'rank')[0];
    if (rankChange) {
      rank = secondsInPast(new Date(rankChange.updated), delaySeconds || 60)
        ? rankChange.current
        : rankChange.previous;
      rank = parseInt(rank, 10);
    }

    //set timeToFirst
    const timeToFirstChange = result_changes.filter(
      (change) => change.type === 'time_to_first'
    )[0];
    if (timeToFirstChange) {
      timeToFirst = secondsInPast(new Date(timeToFirstChange.updated), delaySeconds || 60)
        ? timeToFirstChange.current
        : timeToFirstChange.previous;
    }
  }

  resultDate = new Date(result.result_time ? result.result_time : result);
  inPast = secondsInPast(resultDate, delaySeconds || 60);

  const getResult = () => {
    if (status === 'result') {
      if (rank !== 1) {
        let time = convertTime(timeToFirst, 0);

        //hide zeros
        if (time.startsWith('0:0:')) {
          time = time.slice(4);
        }
        if (time.startsWith('0:')) {
          time = time.slice(2);
        }
        return `+ ${time}`;
        //hide zeros
      }
      // return `+ ${time}`;
    } else if (timeToFirst && rank > 1) {
      let time = convertTime(timeToFirst, 0);

      //hide zeros
      if (time.startsWith('0:0:')) {
        time = time.slice(4);
      }
      if (time.startsWith('0:')) {
        time = time.slice(2);
      }

      return `+ ${time}`;
    }

    return convertTime(time, 0);
  };

  return (
    <>
      {inPast && (
        <>
          <motion.tr
            className={`${style.athlete}${index < 3 ? ' text-white' : ''}`}
            positionTransition
            initial={{ opacity: 0, height: animate ? 54 : 24 }}
            transition={{
              opacity: {
                duration: animate ? 3 : 0.5,
                delay: animate ? 3.5 : 0
              },
              height: {
                duration: 1,
                delay: animate ? 2 : 0
              }
            }}
            animate={{ opacity: 1, height: 24 }}
            key={last_name}
          >
            <td className={`${style.rank} font-mono text-right${index < 3 ? ' text-red' : ''}`}>
              {rank !== 0 && !approaching ? rank : ' '}
            </td>
            <td className={`${style['flag-td']}`}>
              <img className={`${style.flag}`} src={CountryFlag(iso3)} alt={iso3} />
            </td>
            <td className={`${style.name}${index < 3 ? ' text-white' : ''}`}>
              {first_name && first_name.toLowerCase()}{' '}
              {last_name && last_name.toLowerCase()}
              {athlete.wildcard === true && (
                <>
                  {' '}
                  <span style={{ fontSize: "0.9rem" }}>(WC)</span>
                </>
              )}
            </td>
            <td className={`${style.time} font-mono${index < 1 ? ' text-white' : ''}`}>
              {!approaching && getResult()}
            </td>
          </motion.tr>
          <Advertisement advertising={advertising} show={animate} />
        </>
      )}
    </>
  );
};

export { Athlete };
